import styled from "styled-components";
import { colors } from "../../assets";

export const PrivilegesContainer = styled.div`
  margin-bottom: 80px;

  .filter-container {
    width: 100%;
    display: flex;
    gap: 20px;
  }

  .filter-input {
    width: 200px;
  }

  .filter-select {
    flex-grow: 1;
    max-width: 65%;

    > div {
      width: 100%;
      height: 48px;
      border: 1px solid #dcdcdc;
      background-color: #fff;
      border-radius: 4px;
      font-size: 16px;
      padding: 0 10px;
      color: #004a8f;
      transition: background-color 0.2s ease;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      font-weight: 500;
    }

    .input-box-main-field {
      border: none;
      height: 46px;
    }
  }
  .filter-search {
    height: 80px;
    width: 180px;
    margin-top: 14px;

    .main-button-icon {
      width: 18px;
      margin-right: 10px;
    }
  }

  .save {
    &-row {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }

    &-button {
      width: 180px;
    }
  }

  .table {
    &-limit {
      overflow: scroll;
      max-height: 55vh;
    }

    text-transform: initial;
    min-width: initial;

    th,
    td {
      height: initial;
      word-break: initial;
      vertical-align: middle;
    }

    tbody .main-table-row {
      &:hover {
        background-color: ${colors["disabled"]};
      }
      td {
        background-color: initial;
      }
    }

    .inputBox {
      height: initial;
    }

    .dicotomic {
      display: block;
      color: ${colors["TX-001-80"]};
      outline: none;

      .checkbox-container input:not(:checked) {
        color: ${colors["TX-001-50"]};
      }

      &.optional {
        .checkbox-container input:checked ~ .checkmark-container {
          background: ${colors["SU-001-10"]};

          .checkmark-item {
            background: ${colors["SU-001-100"]};
          }
        }
      }

      .checkbox-container {
        display: flex;
        align-items: flex-start;
        position: relative;
        cursor: pointer;

        div:nth-of-type(2) {
          line-height: 25px;
          font-size: 16px;
        }

        input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 0;
          width: 0;

          &:checked ~ .checkmark-container {
            background: ${colors["FL-001-Disabled"]};
            justify-content: flex-end;

            .checkmark-item {
              background: ${colors["PR-001-100"]};
            }

            img {
              max-width: 14px;
            }
          }
        }
      }

      .checkmark-container {
        min-width: 45px;
        background: #e0e0e0;
        padding: 2px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-right: 14px;
        transition: 0.3s all ease-in-out;
        border-radius: 5px;

        img {
          max-width: 10px;
        }
      }

      .checkmark-item {
        background: ${colors["TX-001-30"]};
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        width: 20px;
        height: 20px;
      }
    }
  }
`;
